/**
 * Mirrors of the server-side feedback enums
 * (`common/cscore/api_types/db_enums.py`). The numeric values are the wire
 * contract — if one changes there it must change here, which is why both
 * sides use explicit numbers rather than positional ordering.
 */

export const FEEDBACK_STATUS = {
  NEW: 1000,
  PROCESSED: 2000,
} as const;

export const FEEDBACK_TYPE = {
  BUG: 1000,
  FAILURE: 2000,
  REQUEST: 3000,
  QUESTION: 4000,
  OTHER: 9000,
} as const;

export const PRODUCT_AREA = {
  PORTAL: 1000,
  NUMERICAL_MODELS: 2000,
  NIMBUS: 3000,
  ALTOSTRATUS: 4000,
  STRATUS: 5000,
  TEMPO: 6000,
  FORMA: 7000,
} as const;

/** Ordered for display — the order users read them in the pickers. */
export const FEEDBACK_TYPE_OPTIONS: { value: number; label: string; hint: string }[] = [
  { value: FEEDBACK_TYPE.BUG, label: 'Bug', hint: 'Something works, but wrongly' },
  { value: FEEDBACK_TYPE.FAILURE, label: 'Failure', hint: 'Something did not work at all' },
  { value: FEEDBACK_TYPE.REQUEST, label: 'Request', hint: 'Something you would like added' },
  { value: FEEDBACK_TYPE.QUESTION, label: 'Question', hint: 'You are not sure how it should work' },
  { value: FEEDBACK_TYPE.OTHER, label: 'Other', hint: 'Anything else' },
];

export const PRODUCT_AREA_OPTIONS: { value: number; label: string }[] = [
  { value: PRODUCT_AREA.PORTAL, label: 'Portal' },
  { value: PRODUCT_AREA.NUMERICAL_MODELS, label: 'Numerical Models' },
  { value: PRODUCT_AREA.NIMBUS, label: 'Nimbus' },
  { value: PRODUCT_AREA.ALTOSTRATUS, label: 'Altostratus' },
  { value: PRODUCT_AREA.STRATUS, label: 'Stratus' },
  { value: PRODUCT_AREA.TEMPO, label: 'Tempo' },
  { value: PRODUCT_AREA.FORMA, label: 'Forma' },
];

export const FEEDBACK_TYPE_LABELS: Record<number, string> = Object.fromEntries(
  FEEDBACK_TYPE_OPTIONS.map((option) => [option.value, option.label]),
);

export const PRODUCT_AREA_LABELS: Record<number, string> = Object.fromEntries(
  PRODUCT_AREA_OPTIONS.map((option) => [option.value, option.label]),
);

export const FEEDBACK_STATUS_LABELS: Record<number, string> = {
  [FEEDBACK_STATUS.NEW]: 'New',
  [FEEDBACK_STATUS.PROCESSED]: 'Processed',
};

/** Images only — matches ALLOWED_CONTENT_TYPES in feedback_s3_service.py. */
export const ALLOWED_ATTACHMENT_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const MAX_ATTACHMENTS_PER_REPORT = 5;

/** Only the portal knows anything about portal screen state. */
export const CONTEXT_CAPTURE_AREAS: number[] = [PRODUCT_AREA.PORTAL];
